export const DISABLED_STATUSES_EMPLOYEE = {
	30: 'onboard_label_already_in_process',
	40: 'onboard_label_already_in_business'
};

export const DISABLED_STATUSES_IPA = {
	20: 'onboard_label_already_in_signing',
	...DISABLED_STATUSES_EMPLOYEE
};

export const COLOR_THEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary'
};

export const MIFID_STATUS = {
	MifidStatusUnknown: 0,
	HasFinishedMifid: 1,
	HasNotFinishedMifid: 2,
	NeedsRiskQRenewal: 3
};

export const DEFAULT_MIFID_STATUS = {
	mifidStatus: MIFID_STATUS.MifidStatusUnknown
};

export const FLOW_TYPE_TO_NUMBER = {
	EB: 1,
	MV: 2,
	ER: 4,
	AV: 5,
	ES_MV: 6
};

export const TEST_TYPE_INT = {
	APPROPRIATENESS: 1,
	SUITABILITY: 2,
	NONE: 3
};

export const STATUS = {
	UNKNOWN: 0,
	SUCCESS: 1,
	ERROR: 2,
	NO_ID: 3
};

export const AGREEMENT_PROCESS_FLOW_TYPE = {
	PrivateBankingOnboarding: 1,
	InvestmentBankingOnboarding: 2,
	RiskQRenewal: 3,
	AssetCounseling: 4,
	DerivativesInvestment: 5,
	PortfolioCreation: 6
};
